import { cn } from "~/ui-rtk/utils/tailwind-utils"

type NavigationDotsProps = {
  total: number
  activeIndex: number
  onSelect: (index: number) => void
  className?: string
  size?: "sm" | "md"
}

export default function NavigationDots({
  total,
  activeIndex,
  onSelect,
  className,
  size = "sm",
}: NavigationDotsProps) {
  if (total <= 1) return null

  const dotSizeClass = size === "sm" ? "w-1.5 h-1.5" : "w-2 h-2"
  const activeDotWidthClass = size === "sm" ? "w-3" : "w-4"

  return (
    <div className={cn("flex items-center gap-1.5", className)}>
      {Array.from({ length: total }).map((_, idx) => (
        <button
          key={idx}
          onClick={() => onSelect(idx)}
          className={cn(
            "rounded-full transition-all duration-200",
            dotSizeClass,
            idx === activeIndex
              ? `bg-system-brand-pink-500 ${activeDotWidthClass}`
              : "bg-system-gray-600 hover:bg-system-gray-500",
          )}
          aria-label={`Go to item ${idx + 1}`}
        />
      ))}
    </div>
  )
}
